import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class JUAccountMenuDialogWrapper extends TKCustomElementFactory {
    dialog: HTMLDialogElement | null;
    dialogObserver: MutationObserver | null;
    accountButton: HTMLElement | null;

    constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.dialogObserver = null;
        this.accountButton = this.querySelector('ju-account-button');
    }

    connectedCallback(): void {
        // this.initDialogObserver();
        this.registerEventListeners();
    }

    registerEventListeners() {
        this.initDocumentClickListener();
    }

    // #region Dialog observer
    initDialogObserver() {
        if (!this.dialog) throw new Error('Missing dialog element!');

        const observerConfiguration = {
            attributes: true,
            attributeFilter: ['open'],
            subtree: false,
        };

        this.dialogObserver = new MutationObserver((mutations) => {
            this.onDialogMutation(mutations);
        });
        this.dialogObserver.observe(this.dialog, observerConfiguration);
    }

    onDialogMutation(mutations: MutationRecord[]) {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open') {
                this.onDialogOpend();
            }
        });
    }

    onDialogOpend() {
        // Tbd
    }
    // #endregion

    initDocumentClickListener() {
        const documentClickedAction = this.onDocumentClicked.bind(this);

        this.pushListener({
            event: 'click',
            element: document,
            action: documentClickedAction,
        });
    }

    onDocumentClicked(event: MouseEvent) {
        this.closeDialogIfOutside(event);
    }

    closeDialogIfOutside(event: MouseEvent) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */

        if (
            (event.clientX === 0 && event.clientY === 0)
            || !this.dialog
            || !this.dialog.open
            || (event.target === this.accountButton)
            || (event.target as HTMLElement).closest('ju-button-dropdown')
        ) return;

        const dialogDimensions = this.dialog.getBoundingClientRect();
        if (
            event.clientX < dialogDimensions.left
            || event.clientX > dialogDimensions.right
            || event.clientY < dialogDimensions.top
            || event.clientY > dialogDimensions.bottom
        ) {
            this.dialog.close();
        }
    }
}
